import { nativeEnum, object, string, union, unknown, z } from "zod";

import { EVENT_CODES } from "@/constants/eventCodes";

export const CreatePhoneCallResponseDTOError = object({
  requestDTO: object({
    dataMap: object({
      error: string(),
      eventCode: nativeEnum(EVENT_CODES).optional(),
    }),
  }),
});

export const CreatePhoneCallResponseDTOSuccess = unknown();

export type CreatePhoneCallResponseDTOSuccess = z.infer<
  typeof CreatePhoneCallResponseDTOSuccess
>;

export type CreatePhoneCallResponseDTOError = z.infer<
  typeof CreatePhoneCallResponseDTOError
>;

export const CreatePhoneCallResponseDTO = union([
  CreatePhoneCallResponseDTOError,
  CreatePhoneCallResponseDTOSuccess,
]);

export type CreatePhoneCallResponseDTO = z.infer<
  typeof CreatePhoneCallResponseDTO
>;
